import React from 'react';
import styled from 'styled-components';
import { useAgile } from '@agile-ts/react';
import {
  plane,
  SpriteWrapper,
  reli,
} from '../../../../../../core/entities/relibirds/sprites';
import { relibirds } from '../../../../../../core';
import { SHOW_COLLIDERS } from '../../../../../../core/entities/relibirds';

const Bird: React.FC<Props> = (props) => {
  const { sprite } = props;
  const showCollider = useAgile(SHOW_COLLIDERS);

  return (
    <SpriteWrapper
      gameSprite={sprite}
      collisionBoxColor={showCollider ? 'purple' : undefined}
    >
      <HeadContainer>{reli[sprite.skin]}</HeadContainer>
      <VehicleContainer>{plane}</VehicleContainer>
    </SpriteWrapper>
  );
};

export default Bird;

type Props = {
  sprite: relibirds.Bird;
};

const VehicleContainer = styled.div`
  z-index: 1;
`;

const HeadContainer = styled.div`
  position: absolute;
  top: -10px;
  left: 20px;
  z-index: 2;
`;
